
import { userRoles } from '@/constants/userRoles';
import { UserInfo } from '@/types/user-info';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({
    components: {},
})
export default class Drawer extends Vue {
    // @Prop({ required: true })
    // ResetDevices!: () => void;

    @State('user')
    user!: UserInfo;

    @Prop({ required: true })
    onLogoClick!: () => void;

    handleMenuItemClick() {
        // this.ResetDevices();
        this.onLogoClick();
    }

    get enterpriseUser() {
        if (this.user.roles.includes(userRoles.Enterprise) || this.user.roles.includes(userRoles.EnterpriseNoApi)) {
            return true;
        }
        return false;
    }
}
